import { useRef, useState } from "react";
import { toast } from "sonner";
import { tasksApi } from "@/lib/api";

// Nimmt Audio über das Mikrofon auf und transkribiert es via Whisper-Backend.
export function useVoiceRecorder({ onResult, lang, onError }) {
  const [recording, setRecording] = useState(false);
  const [processing, setProcessing] = useState(false);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]);
  const streamRef = useRef(null);

  const supported =
    typeof navigator !== "undefined" &&
    !!navigator.mediaDevices &&
    typeof window !== "undefined" &&
    typeof window.MediaRecorder !== "undefined";

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      const recorder = new MediaRecorder(stream);
      chunksRef.current = [];
      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };
      recorder.onstop = async () => {
        streamRef.current?.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunksRef.current, { type: recorder.mimeType || "audio/webm" });
        setProcessing(true);
        try {
          const text = await tasksApi.transcribe(blob, lang);
          if (text) onResult(text);
          else toast.error(onError || "Kein Text erkannt.");
        } catch (err) {
          toast.error(onError || "Spracherkennung fehlgeschlagen.");
        } finally {
          setProcessing(false);
        }
      };
      recorderRef.current = recorder;
      recorder.start();
      setRecording(true);
    } catch (err) {
      toast.error("Mikrofonzugriff verweigert.");
    }
  };

  const stop = () => {
    if (recorderRef.current && recorderRef.current.state !== "inactive") {
      recorderRef.current.stop();
    }
    setRecording(false);
  };

  const toggle = () => (recording ? stop() : start());

  return { recording, processing, toggle, supported };
}
